import React, { useEffect, useState } from 'react';
import { useFeathers } from '../../app/util';
import { SearchableSelectInput } from '../SearchableSelectInput';

const OfficeSelectInput = ({
  value,
  onChange,
  style = {},
  clearAfterSelect = false,
  restrictToOfficesWithDistrictTypes = null,
  descendantOf = null,
  excludeOfficeKeys = []
}) => {
  const feathers = useFeathers();

  const [ optionsForField, setOptionsForField ] = useState([]);
  const [ loadingForField, setLoadingForField ] = useState([]);  // an array of timestamps
  const [ loading, setLoading ] = useState(false);
  const [ queuedResultsForField, setQueuedResultsForField ] = useState(null);

  const searchForField = async (searchText) => {
    if(!feathers) return;

    // get time with milliseconds
    const timestamp = Date.now();
    setLoadingForField(l => [...l, timestamp]);
    setLoading(true)

    const offices = await feathers.getService('offices').find({ query: {
      ...(searchText ? { name: { $search: searchText } } : {}),
      ...(restrictToOfficesWithDistrictTypes ? { districtTypes: { $in: restrictToOfficesWithDistrictTypes } } : {}),
      ...(descendantOf ? { district: { $within: descendantOf }} : {}),
    }})
    let options = offices.data
      .filter(office => !excludeOfficeKeys.includes(office.key))
      .map(({ name, _id, ...rest }) => ({ text: name, _id, name, ...rest }));

    setQueuedResultsForField({
      timestamp,
      options
    })
  }

  useEffect(() => {
    if(queuedResultsForField) {
      setQueuedResultsForField(null);

      const mostRecentTimestamp = loadingForField[loadingForField.length - 1];
      const isMostRecentResult = mostRecentTimestamp === queuedResultsForField.timestamp;
      if(!isMostRecentResult) return;

      // we do this so that we only acknowledge the most recent timestamp
      setOptionsForField(queuedResultsForField.options);
      setLoading(false);
    }
  }, [queuedResultsForField, loadingForField ])

  return (
    <SearchableSelectInput
      name='office'
      onChangeSearchText={(searchText) => searchForField(searchText)}
      value={value}
      onChange={onChange}
      optionsLoading={loading}
      options={optionsForField|| []}
      style={style}
      clearAfterSelect={clearAfterSelect}
    />
  )
}

export { OfficeSelectInput }; 